module.exports = __webpack_public_path__ + "img/3手机.56c8894b.png";